import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_UTILITY_USER_SMS_CODE_SIGNUP } from 'api/utilityActionTypes';

import { UTILITY_USER_SESSION_PROVIDER_VERIFICATION_CODE } from 'common/utility/userRoles';

import { onLogicSuccess } from 'client/actions/UtilityAuth/userSignup';

export default async function userSmsCodeSignup({ state, utilityApiClient }, params) {
  typeCheck('params::NonEmptyObject', params);

  const analyticsSessionId = state.get(['analytics', 'analyticsSessionId']);
  const experimentActiveVariants = state.get(['analytics', 'experiments', 'utilityActiveVariants']);

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_USER_SMS_CODE_SIGNUP,
    state: state,
    payload: {
      code: params.code,
      user: {
        firstName: params.firstName,
        lastName: params.lastName || null,
        email: params.email,
        phone: params.phone,
        analyticsSessionId,
        experimentActiveVariants,
        sessionProvider: UTILITY_USER_SESSION_PROVIDER_VERIFICATION_CODE,
      },
      addressId: params.address.id,
      utilityPartnerId: params.utilityPartnerId,
      leaseStartDate: params.leaseStartDate,
    },
    onSuccess({ user }) {
      state.set('utilityUser', user);
      state.commit();

      return onLogicSuccess({
        state,
        utilityApiClient,
        user,
      }).then(() => {
        params.onSuccess(user);
      });
    },
    onError: params.onError,
  });
}
